"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.now = void 0;
var fdatetime_1 = require("./fdatetime");
/**
 * aktualna data i czas w formacie yyyy-MM-dd HH:mm:ss
 */
function now() {
    return (0, fdatetime_1.default)(new Date());
}
exports.now = now;
exports.default = now;
//# sourceMappingURL=now.js.map